export const usePaymentStore = defineStore('payment', () => {
  const { $api } = useNuxtApp()
  const selected = ref<any>(null)
  const options = ref<any>(null)
  const requirements = ref<any>({ '': false })
  const coupons = ref<Array<string>>([])
  const methods = ref<Array<any>>([])

  const addCoupon = async (coupon:string) => {
    if (!coupon || (coupons.value.length && coupons.value[0].includes(coupon.toUpperCase()))) {
      throw new Error('Coupon already applied')
    }
    // @ts-ignore @TODO: Fix typescript typings for $api
    const data = await $api(`/coupons/${coupon.toUpperCase()}`, { recaptchaKey: 'coupon' })
    if (data) {
      coupons.value = []
      coupons.value.push(coupon.toUpperCase())
      return coupon.toUpperCase()
    }
  }

  const removeCoupon = (coupon:string) => {
    const index = coupons.value.findIndex(item => {
      return item.toUpperCase() === coupon.toUpperCase()
    })
    coupons.value.splice(index, 1)
  }

  const resetCoupon = () => {
    coupons.value = []
  }

  const setRequirement = ({ type, value } : {type:string, value:string}) => {
    requirements.value[type] = value
  }

  const resetRequirement = () => {
    requirements.value = { '': false }
  }

  return {
    selected,
    options,
    requirements,
    coupons,
    methods,
    addCoupon,
    removeCoupon,
    resetCoupon,
    setRequirement,
    resetRequirement
  }
}, {
  persistedState: {
    persist: true,
    includePaths: ['coupons']
  }
})
